import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, Text, TextInput } from '@mantine/core';

import { useAddTgPage } from '../../api/addTgPage';
import { useAddTgPageForm } from '../../hooks/useAddTgPageForm';

import { Departments } from '@/types';

type Props = {
  department: Departments;
};

export const AddTgPageModal = NiceModal.create(({ department }: Props) => {
  const modal = useModal();
  const form = useAddTgPageForm({ department });

  const { mutate, isLoading } = useAddTgPage({ config: { onSuccess: modal.remove } });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="New Telegram Page"
    >
      <form onSubmit={form.onSubmit((data) => mutate(data))}>
        <Text mt="sm" mb="xs" size="sm">
          Name
        </Text>
        <TextInput required placeholder="Page name" mb="xl" {...form.getInputProps('name')} />
        <Text mt="sm" mb="xs" size="sm">
          Username
        </Text>
        <TextInput
          required
          placeholder="Page username"
          mb="xl"
          {...form.getInputProps('username')}
        />
        <Text mb="xs" size="sm">
          Phone
        </Text>
        <TextInput required placeholder="Page phone" mb="xl" {...form.getInputProps('phone')} />
        <Text mb="xs" size="sm">
          Department
        </Text>
        <TextInput required {...form.getInputProps('department')} disabled mb="xl" />
        <Group justify="right">
          <Button loading={isLoading} type="submit">
            Add
          </Button>
        </Group>
      </form>
    </Modal>
  );
});
